
/* APPLICATION ROUTE CONSTANTS */

module.exports = Object.freeze({
  
    ROW_PER_PAGE : [10, 50, 100, 300, 500],
    ROW_REPORT_PER_PAGE : [100, 200, 300, 400, 500],

    // Status
    STATUS_REGISTER:'Register',

    /* Routers Link supplier_app */
    APP_HOME: '/applications',
    HOME: '/home',
    
    HOME_INTRO:'/customer-intro',
    DASHBOARD: '/customer-dashboard',
    INBOX: '/customer-inbox',
    OUTBOX: '/customer-outbox',

    /*Customer*/
    CUSTOMER_REGISTRATION: '/customer-registration',
    CUSTOMER_LIST: '/customer-list',
    CUSTOMER_MASS_UPLOAD: '/customer-mass-upload',
    CUSTOMER_MASTER_CREATE: '/customer-master-creation',
    CUSTOMER_SELF_REGISTRATION: '/customer-self-registration',
    CUSTOMER_DETAILED_PAGE_CREATE:'/customer-details',
    CUSTOMER_DETAILED_PAGE_WORKFLOW:'/customer-details-workflow',
    CUSTOMER_DETAILED_PAGE_V4_WORKFLOW:'/customer-details-v4-workflow',

    /*PreSales*/
    PRESALES_INQUIRY_CREATION:'/customer-inquiry-create',
    PRESALES_INQUIRY_LIST:'/customer-inquiry',
    PRESALES_INQUIRY_DETAILS:'/customer-inquiry-details',

    PRESALES_CUSTOMER_CREATE_QUOTATION:'/customer-create-quotation',
    PRESALES_CUSTOMER_QUOTATION_DETAILS:'/customer-quotation-details',
    PRESALES_CUSTOMER_QUOTATION_LIST: '/customer-quotation',
    PRESALES_CUSTOMER_QUOTATION_CREATE_PO: '/create-po-quotation',

    /*Sales*/
    SALES_PURCHASE_ORDER_LIST:'/customer-purchase-order',
    SALES_PURCHASE_ORDER_CREATION:'/customer-create-purchase-order',
    SALES_PURCHASE_ORDER_DETAILS:'/customer-purchase-order-detail',

    SALES_SALES_ORDER_LIST:'/sales-order',
    SALES_SALES_ORDER_CREATION:'/create-sales-order',
    SALES_SALES_ORDER_DETAILS:'/sales-order-detail',
    
    SALES_DELIVERY_CREATION:'/create-delivery',
    SALES_DELIVERY_LIST:'/delivery',
    SALES_DELIVERY_DETAILS:'/delivery-detail',

    /* UserManual */
    USER_MANUAL_CUSTOMER_MANUAL:'/customer-manual',
    USER_MANUAL_MANAGER_MANUAL:'/manager-manual',

    //REPORTS
    CUSTOMER_REPORTS:'/customer-reports',
    CUSTOMER_REPORT_DETAILS:'/customer-report-details',

    /* catalog */
    PRODUCT_CATALOG_LIST:'/product-catalog',
    PRODUCT_CATALOG_DETAILS:'/product-catalog-details',
    PRODUCT_CATALOG_MASTER:'/product-catalog-master',

    /* Product Catalog  Shopwise */
    PRODUCT_CATALOG_SHOPWISE:'/product-catalog-shopwise',

    /* CSTOMER INVOICE */
    CUSTOMER_INVOICE_DETAILS:"/customer-invoice-details",
    CUSTOMER_INVOICE_LIST:"/customer-invoice-list",

    /*BILLING */
    CUSTOMER_BILLING:"/billing",
    CUSTOMER_BILLING_DETAILS:"/billing-detials",

    /* customer FEEDBACK */
    CUSTOMER_FEEDBACK:"/customer-feedback",
    CUSTOMER_FEEDBACK_LIST:"/customer-feedback-list",
    
    CUSTOMER_MATERIAL_MASTER_LIST:"/customer-material-master-list",
    
    /* order booking list */
    CUSTOMER_ORDER_BOOKING_LIST:"/customer-order-booking-list",
    CUSTOMER_ORDER_SHEDULING_LIST:"/customer-order-sheduling-list",
    CUSTOMER_LOADING_ADVICE_LIST:"/customer-loading-advice-list",
    CUSTOMER_INVOICE2_LIST:"/customer-invoice2-list",
    CUSTOMER_INVOICE2_DETAILS:"/customer-invoice2-details",
    CUSTOMER_LOADING_ADVICE_DETAILS:"/customer-loading-advice-details",

    
    // -----------------------------------------  CUSTOMER_V1  --------------------------------------------

    
    
    /* Customer Version-1 Self  Registration */
    CUSTOMER_V1_REGISTER: '/customer-register',
    CUSTOMER_V1_REGISTER_LOGIN: '/customerRegister',
    CUSTOMER_V1_CUSTOMER_MASTER_LIST: '/customer-master-list',
    CUSTOMER_V1_CUSTOMER_MASTER: '/customer-master',

    /* Customer Version-1 Self  Registration */
    CUSTOMER_V1_REGISTER_DETAIL: '/customer-register-detail',

    /* Costing Sheet */
    CUSTOMER_V1_COSTING_SHEET:"/costing-sheet",
    CUSTOMER_V1_COSTING_SHEET_LOGIN:"/costingSheet",
    CUSTOMER_V1_COSTING_SHEET_LIST:"/costing-sheet-list",
    CUSTOMER_V1_COSTING_SHEET_DETAILS:"/costing-sheet-details",

    /* Customer Quotation List */
    CUSTOMER_V1_QUOTATION_LIST:"/customer-quotation-list",
    CUSTOMER_V1_QUOTATION_DETAILS:"/customers-quotation-detail",
    CUSTOMER_V1_QUOTATION_CREATION:"/customers-quotation-creation",

    /* KYC Registration form*/
    CUSTOMER_V1_KYC_REGISTRATION_FORM:"/kyc-registration-form",
    CUSTOMER_V1_REFERENCE_CUSTOMER_DETAILS:"/reference-customer-details",

    /* Scheduling */
    CUSTOMER_V1_ORDER_BOOKING_LIST:'/order-booking',
    CUSTOMER_V1_ORDER_SCHEDULING_LIST:'/order-scheduling',
    CUSTOMER_V1_ORDER_COMPLETE_SCHEDULING_LIST:"/order-complete",
    CUSTOMER_V1_ORDER_CANCELLED_SCHEDULING_LIST:"/order-cancelled",
    CUSTOMER_V1_PRE_DISPATCH_LIST:'/pre-dispatch-List',
    CUSTOMER_V1_POST_DISPATCH_LIST:'/post-dispatch-List',
    CUSTOMER_V1_DISPATCH_CONFIRMATION_LIST:'/dispatch-confirmation-List',
    CUSTOMER_V1_DISPATCHED_CUSTOMER_CONFIRM_LIST:'/dispatch-customer-confirm-List',
    CUSTOMER_V1_IOM_CREDIT_NOTE_LIST:'/credit-note-list',

   /* MaterialMaster*/
    CUSTOMER_V1_MATERIAL_MASTER_LIST:'/material-master-list',
    CUSTOMER_V1_MATERIAL_MASTER_CREATION:'/material-master-create',
    CUSTOMER_V1_MATERIAL_MASTER_DETAILS:'/material-master-detail',

    /* PlantMaster*/
    CUSTOMER_V1_PLANT_MASTER_LIST:'/plant-master-list',
    CUSTOMER_V1_PLANT_MASTER_CREATION:'/plant-master-create',
    CUSTOMER_V1_PLANT_MASTER_DETAILS:'/plant-master-detail',

    /* TollMaster*/
    CUSTOMER_V1_TOLL_MASTER_LIST:'/toll-master-list',
    CUSTOMER_V1_TOLL_MASTER_CREATION:'/toll-master-create',
    CUSTOMER_V1_TOLL_MASTER_DETAILS:'/toll-master-detail',

    /*Credit Approval Request Form*/    
    CUSTOMER_V1_CREDIT_POLICY_REQUEST_FORM_DETAILS:'/credit-policy-request-form-details',
    CUSTOMER_V1_CREDIT_POLICY_REQUEST_LIST:'/credit-policy-request-list',

    /* Purchase Order */
    CUSTOMER_V1_PURCHASE_ORDER_LIST:'/purchase-order-list',
    CUSTOMER_V1_PURCHASE_ORDER_CREATION:'/purchase-order-creation',
    CUSTOMER_V1_PURCHASE_ORDER_DETAILS:'/purchase-order-details',

    /* Transportation*/
    CUSTOMER_V1_TRANSPORTAION_CREATION:"/transportation-creation",
    CUSTOMER_V1_TRANSPORTAION_LIST:"/transportation-list",

      // -----------------------------------------  CUSTOMER_V2  --------------------------------------------
      
    /* Customer Version-2 Self  Registration */
    CUSTOMER_V2_REGISTER: '/sv-customer-register',
    CUSTOMER_V2_REGISTER_BY_SALES_OFFICER: '/sv-customer-register-by-sales-officer',
    CUSTOMER_V2_REGISTER_LOGIN: '/sv-customerRegister',
    CUSTOMER_V2_CUSTOMER_MASTER_LIST: '/sv-customer-master-list',
    CUSTOMER_V2_CUSTOMER_MASTER: '/sv-customer-master',

    /* Customer Version-2 Self  Registration */
    CUSTOMER_V2_REGISTER_DETAIL: '/sv-customer-register-detail',

    /* Scheduling */
    CUSTOMER_V2_ORDER_BOOKING_LIST:'/sva-order-booking',//orderbooking one order multiple line items
    CUSTOMER_V2_ORDER_BOOKING_LIST_LINE_ITEM:'/sv-order-booking',
    CUSTOMER_V2_LOADING_ORDER_BOOKING_LIST:'/sv-loading-order-booking',
    CUSTOMER_V2_COMPLETED_ORDER_BOOKING_LIST:'/sv-order-completed-list',
    CUSTOMER_V2_MODIFICATION_ORDER_BOOKING_LIST:'/sv-order-modification-list',
    CUSTOMER_V2_ORDER_BOOKING_UPDATE:"/sv-order-booking-update",//orderbooking one order multiple line items
    CUSTOMER_V2_ORDER_SCHEDULING_LIST:'/sv-order-scheduling',
    CUSTOMER_V2_PRE_DISPATCH_LIST:'/sv-pre-dispatch-list',
    CUSTOMER_V2_POST_DISPATCH_LIST:'/sv-post-dispatch-list',
    CUSTOMER_V2_LOADING_ADVICE_LIST:'/sv-loading-advice-list',
    CUSTOMER_V2_ORDER_BOOKING_CREATION:'/sv-create-order-booking',
    CUSTOMER_V2_NEW_ORDER_BOOKING:'/sv-order-booking-creation',
    
    //cashrequest
    CUSTOMER_V2_CASH_REQUEST_LIST:'/sv-cash-request-list',
    CUSTOMER_V2_CASH_REQUEST_UPDATE:'/sv-cash-request-update',
    CUSTOMER_V2_CASH_REQUEST_CREATE:'/sv-cash-request-create',

    /* CSTOMER INVOICE */
    CUSTOMER_V2_INVOICE_DETAILS:"/sv-customer-invoice-details",
    CUSTOMER_V2_MANUAL_INVOICE_DETAILS:"/sv-customer-manual-invoice-details",
    CUSTOMER_V2_INVOICE_LIST:"/sv-customer-invoice-list",
    CUSTOMER_V2_LOADING_ADVICE_DETAIL:'/sv-loading-advice-detail',
    CUSTOMER_V2_MANUAL_INVOICE_CREATION:"/sv-customer-manual-invoice-create",

    //custoemr_v2-dashboard
    CUSTOMER_V2_DASHBOARD:'/sv-customer-dashboard',
    
    //RFQ 
    CUSTOMER_V2_RFQ_CREATION:'/sv-rfq-creation',
    CUSTOMER_V2_RFQ_CREATION_MANUAL:'/sv-rfq-manual-creation',
    CUSTOMER_V2_RFQ_LIST:'/sv-rfq-list',
    CUSTOMER_V2_RFQ_DETAIL:'/sv-rfq-details',
    CUSTOMER_V2_RFQ_COMMERCIAL_EVALUATION:'/sv-commercial-evaluation',

    //Indent constants
    CUSTOMER_V2_INDENT_CREATION: "/sv-customer-indent-create",
    CUSTOMER_V2_INDENT_LIST: "/sv-customer-indent-list",
    CUSTOMER_V2_INDENT_DETAILS: "/sv-customer-indent-details",
    
    //Purchase Order
    CUSTOMER_V2_PURCHASE_ORDER_CREATION:'/sv-purchase-order-create',
    CUSTOMER_V2_PURCHASE_ORDER_LIST:'/sv-purchase-order-list',
    CUSTOMER_V2_PURCHASE_ORDER_DETAILS:'/sv-purchase-order-details',
    CUSTOMER_V2_PURCHASE_ORDER_DELIVERY_CONFIRM:'/sv-purchase-order-grn-confirm',
    CUSTOMER_V2_PURCHASE_ORDER_DELIVERY_DETIALS:'/sv-purchase-order-grn-detials',
    CUSTOMER_V2_PURCHASE_ORDER_PAYMENT_LIST:'/sv-purchase-order-payment-list', 
   

    //Quotation
    CUSTOMER_V2_QUOTATION_LIST:"/sv-quotation-list",
    CUSTOMER_V2_QUOTATION_CREATION:"/sv-quotation-creation",
    CUSTOMER_V2_QUOTATION_DETAILS:"/sv-quotation-details",


    CUSTOMER_V2_VENDOR_RFQ_LIST:"/sv-vendor-rfq-list",
    CUSTOMER_V2_VENDOR_RFQ_DETAIL:"/sv-vendor-rfq-detail",

    CUSTOMER_V2_VENDOR_QUOTATION_LIST:"/sv-vendor-quotation-list",

    //Bulck Upload
    CUSTOMER_V2_ORDER_BULCK_UPLOAD: "/sv-order-bulck-upload",

    /*Credit Approval Request Form*/    
    CUSTOMER_V2_CREDIT_POLICY_REQUEST_FORM_DETAILS:'/sv-credit-policy-request-form-details',
    CUSTOMER_V2_CREDIT_POLICY_REQUEST_LIST:'/sv-credit-policy-request-list',
    
    //Purchaase
    CUSTOMER_V2_PURCHASE_LIST:"/sv-purchase-list",
    CUSTOMER_V2_PURCHASE_CREATION:"/sv-purchase-creation",
    CUSTOMER_V2_PURCHASE_DETAILS:"/sv-purchase-details",
    
    //custom report
    CUSTOMER_V2_CUSTOM_REPORTS:"/sv-custom-reports",
    CUSTOMER_V2_SALES_OFFICER_CUSTOM_REPORTS:"/sv-sales-officer-custom-reports",


    //Ledgers
    CUSTOMER_LEDGERS:'/customer-ledgers',
    CUSTOMER_LEDGERS_DETAILS:'/customer-ledgers-details',


    CUSTOMER_V2_BANK_STATEMENT: 'sv-bank-statement',
    CUSTOMER_V2_DAILY_EXPENSES: 'sv-cash-expenses',

    CUSTOMER_V2_CASH_EXPENSES_DETAILS: '/sv-cash-expenses-details',
    CUSTOMER_V2_BANK_STATEMENT_DETAILS: '/sv-bank-statement-details',

    CUSTOMER_V2_CASH_EXPENSES2_DETAILS: 'sv-cash-expenses2-details',
    CUSTOMER_V2_CASH_EXPENSES_LIST: 'sv-cash-expenses-list',

    CUSTOMER_V2_PAYMENT_VOUCHER: 'sv-payment-voucher',     
    CUSTOMER_V2_PAYMENT_RECEIPT: 'sv-receipt-voucher',  

    //Employe
    CUSTOMER_V2_EMP_REGISTRATION: '/sv-emp-registration',
    CUSTOMER_V2_EMP_LIST: '/sv-employee-list',
    CUSTOMER_V2_EMP_DETAILS: '/sv-employee-details',

    // Customer V2 Supplier
    SUPPILER_REGISTRATION_SV: '/sv-supplier-registration',
    SUPPILER_LIST_SV: '/sv-supplier-list',
    SUPPILER_MASS_UPLOAD_SV: '/sv-supplier-mass-upload',
    SUPPLIER_MASTER_CREATE_SV: '/sv-supplier-master-creation',
   
    SUPPLIER_REGESTRATION_PAGE_SV:'/sv-supplier-registration-page',
    SUPPLIER_DETAILED_PAGE_SV:'/sv-supplier-detail-page',

    CUSTOMER_V2_COMPANY_REGISTRATION: '/sv-company-registration',        
    CUSTOMER_V2_COMPANY_LIST: '/sv-company-list',                
    CUSTOMER_V2_COMPANY_DETAILS: '/sv-company-details',    
    
    CUSTOMER_V2_MATERIAL_LIST:'/sv-material-list',

    //pitti cash
    CUSTOMER_V2_PETTY_CASH_LIST:'/sv-petty-cash-list',
    CUSTOMER_V2_PETTY_CASH_CREATE:'/sv-petty-cash-create', 
    
    

   // -----------------------------------------  CUSTOMER_V3  --------------------------------------------

    // Customer-V3
    CUSTOMER_V3_CUSTOMER_SELF_REGISTER: "/customer-selfregistrationv3",
    CUSTOMER_V4_CUSTOMER_SELF_REGISTER: "/customer-selfregistrationv4",
    CUSTOMER_V3_CUSTOMER_REGISTRATION: "/customer-registrationv3",
    CUSTOMER_V3_CUSTOMER_DETAILS: "/customerv3-detailpage",
    CUSTOMER_V4_CUSTOMER_DETAILS: "/customerv4-detailpage",
    CUSTOMER_V3_CUSTOMER_WORKFLOW_DETAILS: "/customerv3-workflow-detailpage",
    CUSTOMER_V4_CUSTOMER_WORKFLOW_DETAILS: "/customerv4-workflow-detailpage",
    CUSTOMER_V3_CUSTOMER_LIST: "/customerv3-list",

   // -----------------------------------------  CUSTOMER_V4  --------------------------------------------

    CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN: "/material-price-breakdown",
    CUSTOMER_V4_MATERIAL_PRICE_BREAKDOWN_DETAILS: "/material-price-breakdown-detail",
    
    CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN: "/customer-sales-breakdown",
    CUSTOMER_V4_CUSTOMER_SALES_BREAKDOWN_DETAILS: "/customer-salesbreakdown-details",

    CUSTOMER_V4_QUOTATION_ESTIMATE: "/quotation-estimate",
    CUSTOMER_V4_QUOTATION_ESTIMATE_DETAILS: "/quotation-estimate-details",
    
    CUSTOMER_V4_FINANCE_PRICE_BREAKDOWN_CREATION: "/finance-price-breakdown-creation",

    CUSTOMER_V4_CUSTOMER_ESTIMATE_E1: "/customer-estimate-e1",

//-----------------------------------------  CUSTOMER_V5  --------------------------------------------
    //Dashboard
    CUSTOMER_V5_DASHBOARD:'/mr-dashboard',

    CUSTOMERV5_EQUIPMENT_MASTER_LIST: "/equipment-master-list",
    CUSTOMERV5_RENTREQUEST_LIST: "/rent-request-list",
    CUSTOMERV5_RENTREQUEST_DETAILS: "/rentrequest-list-details",
    CUSTOMERV5_RENTREQUEST_MASTER: "/rentrequest-master", 
   
    /* Customer Version-2 Self  Registration */
    CUSTOMER_V5_REGISTER: '/mr-customer-register',
    CUSTOMER_V5_REGISTER_LOGIN: '/mr-customerRegister',
    CUSTOMER_V5_CUSTOMER_MASTER_LIST: '/mr-customer-master-list',
    CUSTOMER_V5_CUSTOMER_MASTER: '/mr-customer-master',
 
    /* Customer Version-2 Self  Registration */
    CUSTOMER_V5_REGISTER_DETAIL: '/mr-customer-register-detail',
 
    // Customer V5 Supplier
    SUPPILER_REGISTRATION_MR: 'mr-vendor-registration',
    SUPPILER_LIST_MR: '/mr-vendor-list',
    SUPPILER_MASS_UPLOAD_MR: '/mr-vendor-mass-upload',
    SUPPLIER_MASTER_CREATE_MR: '/mr-vendor-master-creation',
   
    SUPPLIER_REGESTRATION_PAGE_MR:'/mr-vendor-registration-page',
    SUPPLIER_DETAILED_PAGE_MR:'/mr-vendor-detail-page',
 
    // Customer V5 vendor
    CUSTOMER_V5_VENDOR_LIST:'/mr-vendor1-list',
    SUPPLIER_V5_SELFREGISTARTION:'/mr-self-registration',

    //Purchase Order
    CUSTOMER_V5_PURCHASE_ORDER_LIST:'/mr-purchase-order-list',
    CUSTOMER_V5_PURCHASE_ORDER_CREATION:'/mr-purchase-order-create',
    CUSTOMER_V5_PURCHASE_ORDER_DETAILS:'/mr-purchase-order-details',
    CUSTOMER_V5_PURCHASE_ORDER_UPDATE:'/mr-purchase-order-udate', 
    
    CUSTOMER_V5_PURCHASE_ORDER_DELIVERY_CONFIRM:'/mr-purchase-order-delivery-confirm',
    CUSTOMER_V5_PURCHASE_ORDER_DELIVERY_DETIALS:'/mr-purchase-order-delivery-detials',
    CUSTOMER_V5_PURCHASE_ORDER_PAYMENT_LIST:'/mr-purchase-order-payment-list',

    CUSTOMER_V5_COMPANY_REGISTRATION_MR: '/mr-company-registration',        
    CUSTOMER_V5_COMPANY_LIST_MR: '/mr-company-list',                
    CUSTOMER_V5_COMPANY_DETAILS_MR: '/mr-company-details',
 
    CUSTOMER_V5_QUALITY_CHECK_LIST_MR:"/mr-quality-check-list",
    CUSTOMER_V5_QUALITY_CHECK_DETAILS_MR:"/mr-quality-check-details",
    CUSTOMER_V5_QUALITY_CHECK_CREATE_MR:"/mr-quality-check-create",
    

    CUSTOMER_V5_MR_POCOLLABRATION_GOODS_RECEIVED_NOTE:'/mr-goods-received-note',
    CUSTOMER_V5_MR_POCOLLABRATION_SERVICE_ENTRY_SHEET_LIST:'/mr-service-entry-sheet',
    CUSTOMER_V5_MR_POCOLLABRATION_GRN_CREATION:'/mr-create-grn',
    CUSTOMER_V5_MR_POCOLLABRATION_GRN_DETAILS:'/mr-goods-received-note-details',
    
    CUSTOMER_V5_MR_POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST:'/mr-service-purchase-order',

      //gate Entery
    CUSTOMER_V5_MR_LOGISTICS_IN_WORD_OUT_WORD_LIST: "/mr-logistics-inward-outward-list",
    CUSTOMER_V5_MR_LOGISTICS_GATE_ENTRY_UPDATE: "/mr-logistics-gate-details",
    CUSTOMER_V5_MR_LOGISTICS_CREATE_GATE_ENTRTY :"/mr-logistics-create-gate-entry",
    CUSTOMER_V5_MR_CREDITNOTE_DEBITNOTE: "/mr-credit-debit-note-list",


    // SES
    CUSTOMER_V5_MR_POCOLLABRATION_SERVICE_ENTRY_DETAILS:'/mr-service-entry-sheet-details',
    CUSTOMER_V5_MR_POCOLLABRATION_SES_CREATION:'/mr-create-entrysheet',

    //material master
    CUSTOMER_V5_MR_MATERIAL_LIST:'/mr-material-list',

    // MATERIAL BARCODE LIST
  CUSTOMER_V5_MR_MATERIAL_BARCODE_LIST:'/mr-material-barcode-list',
  CUSTOMER_V5_MR_MATERIAL_BARCODE_SALE_LIST:'/mr-sale-material-barcode-list',
  CUSTOMER_V5_MR_MATERIAL_BARCODE_RENT_LIST:'/mr-rent-material-barcode-list',
  CUSTOMER_V5_MR_SALE_MATERIAL_IDLE_AGEING:'/mr-sale-material-idle-ageing',
  CUSTOMER_V5_MR_RENT_MATERIAL_IDLE_AGEING:'/mr-rent-material-idle-ageing',

  // ERF
    CUSTOMER_V5_MR_CREATE_ERF:"/mr-create-erf",
    CUSTOMER_V5_MR_ERF_DETAIL:"/mr-erf-detail",
    CUSTOMER_V5_MR_ERF_WORKFLOW_DETAIL:"/mr-erf-workflow-detail",
    CUSTOMER_V5_MR_ERF_LIST:"/mr-erf-list",
    CUSTOMER_V5_MR_STORE_ERF_LIST:"/mr-erf-store",
    CUSTOMER_V5_MR_DISPATCH_ERF_LIST:"/mr-erf-dispatch",
    CUSTOMER_V5_MR_EXTENSION_ERF_LIST:"/mr-pcd-erfextension-list",
    CUSTOMER_V5_MR_EXTENSION_ERF_DETAILS:"/mr-pcd-erf-details",
    CUSTOMER_V5_MR_ERF_PROGRESS_LIST:"/mr-erf-progress-list",

    // SERVICE ERF LIST
    CUSTOMER_V5_MR_ERF_SERVICE_LIST:"/mr-service-erf-list",
    CUSTOMER_V5_MR_ERF_SERVICE_DETAIL_PAGE:"/mr-erf-service-detail-page",
 
    //Doctor Master
    CUSTOMER_V5_MR_USER_REGISTRATION: '/mr-user-registration',
    CUSTOMER_V5_MR_USER_LIST: '/mr-user-list',
    CUSTOMER_V5_MR_USER_DETAILS: '/mr-user-details',

    CUSTOMER_V5_MR_ERF_SUMMARY_DETAILS:"/mr-extesnion-summary-details",
    CUSTOMER_V5_MR_EXTENSION_FOR_ERF_LIST:"/mr-pcd-erf-list",

    CUSTOMER_V5_MR_ERF_INVOICE_LIST:"/mr-erf-invoice-list",
    CUSTOMER_V5_MR_ERF_INVOICE_DETAILS:"/mr-erf-invoice-details",
    CUSTOMER_V5_MR_ERF_SERVICE_PAGE:"/mr-erf-service-page",
    CUSTOMER_V5_MR_DISPATCHED_ERF_LIST:"/mr-erf-dispatched",
    CUSTOMER_V5_MR_SERVICE_PROVIDE_ERF_LIST:"/mr-erf-service-provide",
    CUSTOMER_V5_MR_HOSPITAL_ERF_LIST:"/mr-erf-hospital-list",
    CUSTOMER_V5_MR_ERF_BULCK_INVOICE_CREATION:"/mr-erf-bulck-invoice-creation",

 CUSTOMER_V2_REGISTRATION: '/sv-customer-registration',
 
 


    
    
   
 

    




})  

